/*
  所有事件监听者
*/
Listener = {
  id: document,
  cart: {
    add: {
      before: "cart:add:before",
      after: "cart:add:after"
    },
    change: {
      before: "cart:change:before",
      after: "cart:change:after"
    },
    clear: {
      before: "cart:clear:before",
      after: "cart:clear:after"
    },
    refresh: "cart:refresh"
  },
  collection: {
    build:{
      after: "collection:build:after"
    }
  },
  slideWindow: {
    open: {
      before: "slide-window:open:before",
      after: "slide-window:open:after",
    },
    close: {
      before: "slide-window:close:before",
      after: "slide-window:close:after",
    }
  },
  product: {
    add:{
      before: "product:add:before"
    },
    update: {
      before: "product:update:before",
      after: "product:update:after"
    }
  },
  currency:{
    convert: {
      after: "currency:convert:after"
    }
  },
  coupon:{
    use:{
      before:'coupon:use:before',
      after:'coupon:use:after'
    }
  },
  on: function(events, callback) {
    var event = typeof(events) == 'object' ? events.join(' ') : events;
    $(this.id).on(event, callback);
  },
  trigger: function(event, params) {
    $(this.id).trigger(event, params);
  }
}

Product = {
  options: [],
  variants: [],
  validators: [],
  init: function(data) {

  },
  verify: async function() { // 验证
    var errors = [];
    for(var i = 0; i < this.validators.length; i++){
        var validator = this.validators[i];
        var result = await validator();
        if (result instanceof Promise){
            await result.then(function(res){
                result = res;
            })
        }
        if (result !== true){
            errors.push(result);
        }
    }
    console.log(errors);
    if (errors.length > 0){
        return Promise.reject(errors);
    }else{
        return Promise.resolve();
    }
  },
  addFormToCartUnify: function(form) {

    this.verify().then(function(){ // 验证后

      var quantity = $('[data-quantity-input]').val();
      if(quantity <= 0){
        alert("");
        return false;
      }

      //增加card勾选功能 2020.05.28 by anna
      if($("#card_box").length > 0 && $('#card_id').is(':checked')){
        var cardText = $.trim($("#card_text").val()); 
        if(cardText == undefined || cardText == ''){
          alert("Please Design Your Card.");
          return false;
        }
        if($(".append_html .frame-option").length > 0){
          var cardName = $("#card_name").val();
          var cardTemplate = $("#card_template").val();
          if(cardName == '' || cardTemplate == ''){
            alert("Please Design Your Card.");
            return false;
          }
        }
        if($(".append_html .font-option").length > 0){
          var cardFont = $("#card_fontname").val();
          var cardFontfamily = $("#card_fontfamily").val();
          if(cardFont == '' || cardFontfamily == ''){
            alert("Please Design Your Card.");
            return false;
          }
        }
      }
      
      //增加insurance勾选功能 2020.07.29 by anna
      if($(".product-insurance-div").length > 0 && $('#insuranceBox').is(':checked') == true){
          cateTempInsuranceHtml();
      }
      //增加vip勾选功能
      if($(".product-vip-gift-box-div").length > 0 && $('#vipBox').is(':checked') == true){
          cateTempVipHtml();
      }
      //增加多图毯子加价勾选功能
      if($('input[name="jiajia"]').val()==1){
          cateTempHtml();
      }

      Cart.add({ // 加车
        form
      }).then((item) => { // 加车后

        //增加多图毯子加价勾选功能
        if($('input[name="jiajia"]').val() == 1){
          tempAddToCart();
        }
        //增加vip勾选功能
        if($(".product-vip-gift-box-div").length > 0 && $('#vipBox').is(':checked') == true){
          boxAddToCart();
        }
        //增加insurance勾选功能
        if($(".product-insurance-div").length > 0 && $('#insuranceBox').is(':checked') == true){
          insuranceAddToCart();
        }
        //增加封套产品勾选加车
        if($(".multi-product-plate-box").length > 0 && $('#envelopeService').val() != ''){
          envelopeAddToCart();
        }
        //增加多盒子勾选加车
        if($(".multi-product-gift-box").length > 0){
          multiBoxAddToCart();
        }

        //update tangle num 
        $('#product_addtocart_success').find('.addToCartQty').html($('.product-form__item--quantity').find('#Quantity').val());
        
        if(window.dontAddToCartModal == undefined){ // 放弃弹层变量
          var modal = new tingle.modal({
            footer: false,
            onOpen: function() {
              console.log('modal open');
            },
            onClose: function() {
              console.log('modal closed');
            },
            beforeOpen: function() {
            },
            beforeClose: function() {
              // e.g. save content before closing the modal
              return true; // close the modal
            }
          });

          modal.setContent($('.product-addtocart-success-unify').html());
          modal.open();
          $('.continue-shopping').click(function(){
            modal.close();
          });
        }
          

      })

    }).catch(function(res){
      console.log('Box action Add to Cart Error', res);
    })
  }
}

/*
  购物车功能
*/
Cart = {
  fetch: function() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: (cart) => {
          resolve(cart);
        },
        error: (request, status) => {
          reject(request, status);
        }
      })
    });
  },
  add: function(options = {}) {
    options = Object.assign({
      quantity: 1,
      mask:'body',
      refresh:true
    }, options);
    var data = options;
    if(options.form) {
      data = $(options.form).serialize()
    }
    var promise = new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        async: false,  
        url: "/cart/add.js",
        data,
        dataType: "json",
        context: this,
        beforeSend: (request) => {
          if(options.mask) {
            $(this).find('button[type="submit"]').attr("disabled","disabled");
//             Mask.show(options.mask);
          }
          Listener.trigger(Listener.cart.add.before, [ options.form ]);
        },
        complete(){
          $(this).find('button[type="submit"]').removeAttr("disabled");
        },
        success: (item) => {
          item.quantity = options.quantity;
          Listener.trigger(Listener.cart.add.after, [ item, options.form ]);
          if(options.refresh) {
            this.refresh();
          }
          if(options.mask) {
//             Mask.hide(options.mask);
          }
          resolve(item);
        },
        error: (request, status) => {
          reject(request, status);
        }
      })
    });
    return promise;
  },
  change: function(options = {}, flag = true) {
    options = Object.assign({
      quantity:1,
      mask:'body',
      refresh:true
    }, options);
    if(options.form) {
      data = $(options.form).serialize()
    }else{
      data = options;
    }
    var promise = new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        context: this,
        beforeSend: (request) => {
          if(options.mask) {
//             Mask.show(options.mask);
          }
          Listener.trigger(Listener.cart.change.before);
        },
        success: (item) => {
          if(flag){
            Listener.trigger(Listener.cart.change.after, [ item ]);
            console.log('options.refresh', options.refresh);
          }
          if(options.refresh) {
            this.refresh();
          }
          if(options.mask) {
//             Mask.hide(options.mask);
          }
          resolve(item);
        },
        error: (request, status) => {
          reject(request, status);
        }
      })
    });
    return promise;
  },
  clear: function(options = {}) {
    options = Object.assign({
      mask:'body',
      refresh:true
    }, options);
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        beforeSend: (request) => {
          if(options.mask) {
//             Mask.show(options.mask);
          }
          Listener.trigger(Listener.cart.clear.before);
        },
        success: (cart) => {
          Listener.trigger(Listener.cart.clear.after, [ cart ]);
          if(options.refresh) {
            this.refresh();
          }
          if(options.mask) {
//             Mask.hide(options.mask);
          }
          resolve(cart);
        },
        error: (request, status) => {
          reject(request, status);
        }
      })
    });
  },
  refresh: function(cart = null) {
    if(!cart) {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: (cart) => {
            Listener.trigger(Listener.cart.refresh, [ cart ]);
            resolve(cart);
          },
          error: (request, status) => {
            reject(request, status);
          }
        })
      });
    }else{
      return new Promise(resolve => {
        Listener.trigger(Listener.cart.refresh, [ cart ]);
        resolve(cart);
      });
    }
  }
}
window.addEventListener('VARIANT_CHANGE', function(event){
  var variant = event.detail;
  Listener.trigger(Listener.product.update.before, [ variant ]);
  Listener.trigger(Listener.product.update.after, [ variant ]);
})

/*
 * 全局遮罩
 */
MaskLoadingGif = window.MaskLoadingGif || '//www.mycustommousepad.com/cdn/shop/files/6ad132d8c8981bdf4b5e48e28495bf51724e8628a7564380f13e538b953b0af6QzpcVXNlcnNcZGVsbDU0OTNcQXBwRGF0YVxSb2FtaW5nXERpbmdUYWxrXDIyNDYzMDg4MzlfdjJcSW1hZ2VGaWxlc1wxMzQ0MzEzOVw0Njk2NjY2MjU1XzM_medium.gif?10374';
Mask = {
    css: {
        layer: 'font-size:1.1em;text-align:center;position:fixed;z-index:2147483647;width:100%;height:100%;left:0;top:0;background-color:rgba(255,255,255,0.5);',
      icon: `background:url(${MaskLoadingGif}) no-repeat scroll center;width:100%;height:100%;display:inline-block;`
    },
    show: function (parentElement = 'body') {
        if ($('[data-loading-layer="'+parentElement+'"]').length > 0){
          return;
        }
        if ($(parentElement).length == 0){
          return;
        }
        var layerCss = this.css.layer;
        if (parentElement != 'body'){
            layerCss += `width:${$(parentElement).outerWidth()}px !important;`;
            layerCss += `height:${$(parentElement).outerHeight()}px !important;`;
            if ($(parentElement).css('position') == 'fixed'){
                layerCss += `left:${$(parentElement).position().left}px !important;`;
                layerCss += `top:${$(parentElement).position().top}px !important;`;
            }else{
                layerCss += `left:${$(parentElement).offset().left}px !important;`;
                layerCss += `top:${$(parentElement).offset().top - $(document).scrollTop()}px !important;`;
            }
            $(window).bind('scroll', function() {
              if ($('[data-loading-layer]').length > 0){
                $('[data-loading-layer]').each(function() {
                    var layer = $(this).data('loading-layer');
                    if (layer != 'body'){
                        var element = $(layer)
                        var offsetTop = element.offset().top;
                        var scrollTop = $(document).scrollTop();
                        var top = offsetTop - scrollTop;
                        $(this).css('top', top + 'px');
                    }
                })
              }
            })
        }
        var loadingDom = `<div data-loading-layer="${parentElement}" style="${layerCss}"><div style="${this.css.icon}"></div></div>`;
        $('body').append(loadingDom);
    },
    hide: (parentElement = 'body') => {
        $('[data-loading-layer="'+parentElement+'"]').remove();
        /*if ($('[data-loading-layer]').length == 0){
            $(window).unbind('scroll');
        }*/
    }
}